import { render, staticRenderFns } from "./OfferElement.vue?vue&type=template&id=700d7d70&"
import script from "./OfferElement.vue?vue&type=script&lang=js&"
export * from "./OfferElement.vue?vue&type=script&lang=js&"
import style0 from "./OfferElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports